/**
 * Form that POSTs to the primary region's requestStandardLogin endpoint with email
 * and PKCE in the body (not in the URL), similar to RegionForm for auth redirect.
 * Auto-submits so the user is sent to the primary region and the email is sent from there.
 */
import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

class StandardLoginRegionForm extends React.Component {

    componentDidMount() {
        if (this.formRef) {
            this.formRef.submit();
        }
    }

    render() {
        const {redirectUrl, redirectEmail, redirectCodeChallenge, redirectCodeChallengeMethod} = this.props;
        if (!redirectUrl || !redirectEmail) {
            return null;
        }
        const divStyle = { display: 'none' };
        return (
            <div key="StandardLoginRegionForm_1" style={divStyle}>
                <form ref={el => this.formRef = el} action={redirectUrl} method="post">
                    <input type="hidden" name="email" value={redirectEmail} />
                    {redirectCodeChallenge && (
                        <input type="hidden" name="code_challenge" value={redirectCodeChallenge} />
                    )}
                    {redirectCodeChallengeMethod && (
                        <input type="hidden" name="code_challenge_method" value={redirectCodeChallengeMethod} />
                    )}
                    <button type="submit">Continue</button>
                </form>
            </div>
        );
    }
}

StandardLoginRegionForm.propTypes = {
    redirectUrl: PropTypes.string,
    redirectEmail: PropTypes.string,
    redirectCodeChallenge: PropTypes.string,
    redirectCodeChallengeMethod: PropTypes.string
};

const mapStateToProps = (state) => ({
    redirectUrl: state.login.standardLoginRedirectUrl,
    redirectEmail: state.login.standardLoginRedirectEmail,
    redirectCodeChallenge: state.login.standardLoginRedirectCodeChallenge,
    redirectCodeChallengeMethod: state.login.standardLoginRedirectCodeChallengeMethod
});

export default connect(mapStateToProps)(StandardLoginRegionForm);
